export const UPDATE_CONTEXT = "UPDATE_CONTEXT";
export const UPDATE_PATHNAME_CONTEXTS = "UPDATE_PATHNAME_CONTEXTS";
